import { SelectionWithNoteSourceCitationMixin } from './mixin';
import { SelectionAny } from './internal';
export class SelectionAssociation extends SelectionWithNoteSourceCitationMixin(SelectionAny) {
    getRelation() {
        return this.get("RELA" /* Tag.Relationship */);
    }
}
//# sourceMappingURL=SelectionAssociation.js.map